export const COMMENT_ADD = 'COMMENT_ADD';
export const COMMENT_REQUEST = 'COMMENT_REQUEST';
export const COMMENT_SUCCESS = 'COMMENT_SUCCESS';
export const COMMENT_EMPTY = 'COMMENT_EMPTY';
export const COMMENT_ERROR = 'COMMENT_ERROR';
